import { Component, ViewChildren, QueryList, ViewChild, forwardRef, Input, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'bb-multiselect',
	templateUrl: './bb-multiselect.component.html',
	styleUrls: ['./bb-multiselect.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbMultiselectComponent),
		multi: true
	}]
})

export class BbMultiselectComponent implements ControlValueAccessor {
	@ViewChildren('selectedEntities') selectedEntities: QueryList<ElementRef>;
	@ViewChild('tagInputEntity', { static: true }) tagInputEntity: ElementRef;
	@ViewChild('multiSelectInput') input: any;
	@ViewChild('container', { static: true }) container: any;

	@Input() initialValue: number;


	// TODO: Check if it's safe to remove this component, does not seem to be used anymore
	public selected: boolean;
	public hide: boolean;

	inputValue: string;
	tags: string[];

	searchTerm: Subject<KeyboardEvent>;

	propagateChange: any;

	tagInput: string;

	constructor(protected translate: TranslateService) {
		this.searchTerm = new Subject<KeyboardEvent>();

		this.searchTerm.subscribe((t: any) => {
			if (this.tagInputEntity && this.tagInputEntity.nativeElement) {
				const value = this.tagInputEntity.nativeElement.value;
				if (t.key === 'Enter' || t.key === ',' && this.tagInputEntity.nativeElement.value.length > 0) {
					if (value.search(',') > -1) {
						value.split(',').forEach((tag: string) => {
							this.addTag(tag);
						});
					} else {
						this.addTag(value);
					}
					this.tagInputEntity.nativeElement.value = '';
				}
				this.propagateChange(this.tags);
			}
		});
	}

	addTag(tag: string) {
		tag = tag.trim();
		if (tag.length > 0) {
			let tagIterator = this.tags.length;
			while (tagIterator--) {
				if (this.tags[tagIterator] === tag) {
					this.tags.splice(tagIterator, 1);
				}
			}
			this.tags.push(tag);
		}
	}

	writeValue(value: string[]) {
		this.tags = value || [];
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}

	selectEntity(event: MouseEvent, entityIndex: number) {
		if (event) {
			event.stopPropagation();
		}

		if (this.selectedEntities) {
			const selectedEntitiesLength: number = this.selectedEntities.length;
			if (selectedEntitiesLength > 0) {
				this.selectedEntities.forEach((htmlEntity: ElementRef, index: number) => {
					if (entityIndex === index) {
						htmlEntity.nativeElement.classList.add('selected');
					} else {
						htmlEntity.nativeElement.classList.remove('selected');
					}
				});
			}
		}
	}

	selectTagInput(event: MouseEvent) {
		if (this.tagInputEntity) {
			this.tagInputEntity.nativeElement.focus();
		}
	}

	removeSelectedEntity(tag: string) {
		for (let i = this.tags.length - 1; i >= 0; i-- ) {
			if (this.tags[i] === tag) {
				this.tags.splice(i, 1);
			}
		}

		this.inputValue = '';
		if (typeof this.propagateChange !== 'undefined') {
			this.propagateChange(this.tags);
		}
	}
}
